import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const myDoctorsRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.myDoctors.route,
      lazy: () => import("@pages/panelPages/myDoctors/myDoctors"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.myDoctors", [], "index", "main");
        return {};
      },
    },
    permissions: ["staff"],
  },
];
